import { PlusIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "antd";
import { Button } from "V2.0/common/button";

export default AddStepAction;

function AddStepAction(props) {
  const { onAddStep } = props;

  return (
    <Button
      plain
      onClick={(e) => {
        e.stopPropagation();
        onAddStep();
      }}
    >
      <Tooltip title="Add Step">
        <PlusIcon />
      </Tooltip>
    </Button>
  );
}
